import CryptoJS from "crypto-js";
import { v4 as uuidv4 } from "uuid";

// Configuration variables
//const baseUrl = "https://development.academia.ly";
//const apiUrl = "https://development.academia.ly/api";

//const baseUrl = "https://academia.speetar.com";
//const apiUrl = "https://academia.speetar.com/api";
//const baseUrl = "https://system.academia.ly";
//const apiUrl = "https://system.academia.ly/api";
//const apiUrl = "https://academia.org.ly/api";
//const baseUrl = "https://academia.org.ly";
//const baseUrl = "https://dev.academia.org.ly";
//const apiUrl = "https://dev.academia.org.ly/api";
//const apiUrl = "https://system.academia.education/api";
//const baseUrl = "https://system.academia.education";
const baseUrl = "https://dev.academia.org.ly";
const apiUrl = "https://dev.academia.org.ly/api";
const hashingKey = "OPWQDLFKJRDJFHSDCFREDGSXCVDYUIOW";
const hashingIv = "O1HYA5YWKS4DKB9T";
const appSecret = "a463c0cd-78ed-4bda-a5f6-f70c3e597dfb";
const seperationString = "&&@?";
const courseImagePath = `${baseUrl}/images/course/`;
const instructorImagePath = `${baseUrl}/images/user_img/`;
const userImagePath = `${baseUrl}/images/user_img/`;
const deviceId = getDeviceId();
const OS = "windows";
const videoPrefix = "https://d1fnkomyarsq9x.cloudfront.net/";
const drmPlayerUrl = "https://drm.academia.ly";

// Utility functions
function getDeviceId() {
  let machineId = localStorage.getItem("DeviceId");
  if (!machineId) {
    machineId = uuidv4();
    localStorage.setItem("DeviceId", machineId);
  }
  return machineId;
}

function getBrowserName() {
  const test = (regexp) => regexp.test(window.navigator.userAgent);
  switch (true) {
    case test(/edg/i):
      return "Microsoft Edge";
    case test(/trident/i):
      return "Microsoft Internet Explorer";
    case test(/firefox|fxios/i):
      return "Mozilla Firefox";
    case test(/opr\//i):
      return "Opera";
    case test(/ucbrowser/i):
      return "UC Browser";
    case test(/samsungbrowser/i):
      return "Samsung Browser";
    case test(/chrome|chromium|crios/i):
      return "Google Chrome";
    case test(/safari/i):
      return "Apple Safari";
    default:
      return "Other";
  }
}

function hash(data) {
  const key = CryptoJS.enc.Utf8.parse(hashingKey);
  const iv = CryptoJS.enc.Utf8.parse(hashingIv);
  const now = +new Date();
  let payload = `{"sigDate": "${now}","OS": "${OS}","Skey": "${appSecret}","device_id": "${deviceId}"}`;
  let stringHash = `${now}${seperationString}${OS}${seperationString}${appSecret}${seperationString}${deviceId}`;
  for (const [key, value] of Object.entries(data)) {
    stringHash = `${stringHash}${seperationString}${value}`;
    payload += `,"${key}": "${value}"`;
  }
  payload += `,"string_hash": "${CryptoJS.AES.encrypt(stringHash, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
  }).toString()}"}`;
  return payload;
}

function hashV2(data) {
  const key = CryptoJS.enc.Utf8.parse(hashingKey);
  const iv = CryptoJS.enc.Utf8.parse(hashingIv);
  const now = +new Date();
  let payload = `{"sigDate": "${now}","OS": "${OS}","Skey": "${appSecret}","device_id": "${deviceId}"`;
  let stringHash = `${now}${seperationString}${OS}${seperationString}${appSecret}${seperationString}${deviceId}`;
  for (const [key, value] of Object.entries(data)) {
    stringHash = `${stringHash}${seperationString}${value}`;
    payload += `,"${key}": "${value}"`;
  }
  payload += `,"string_hash": "${CryptoJS.AES.encrypt(stringHash, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
  }).toString()}"}`;
  //console.log(payload);
  return JSON.parse(payload);
}

function unhash(hash) {
  const key = CryptoJS.enc.Utf8.parse(hashingKey);
  const iv = CryptoJS.enc.Utf8.parse(hashingIv);
  const data = CryptoJS.AES.decrypt(hash, key, { iv });
  return data;
}

async function api(url, method, body, headers, enc = false) {
  body = enc ? hash(body) : JSON.stringify(body);
  return fetch(`${apiUrl}${url}`, {
    method,
    headers: { "Content-Type": "application/json", ...headers },
    body,
  });
}

async function api_get(url, headers) {
  return fetch(`${apiUrl}${url}`, {
    headers: { "Content-Type": "application/json", ...headers },
  });
}

// Exporting the functions and variables
export {
  baseUrl,
  apiUrl,
  courseImagePath,
  instructorImagePath,
  userImagePath,
  videoPrefix,
  drmPlayerUrl,
  deviceId,
  getBrowserName,
  api,
  api_get,
  hash,
  hashV2,
  unhash,
};
